import { getFramework } from '@/framework';
import { getCharTypedMarkerText } from '@/utils/text-kit';
import { type ILayerBehavior, type IVectorLayerProps } from '@/version-types';

type Behaviors = Pick<ILayerBehavior, 'isTextEditable' | 'getTextInfo'>;

export const createTextBehaviors = (identity: string) => {
    const behaviors: Behaviors = {
        isTextEditable() {
            const framework = getFramework(identity);
            return !framework.service.edgelessCanvas.isEdgelessMode;
        },

        getTextInfo(layer) {
            const layerData = layer.data as IVectorLayerProps;
            const { textInfo } = layerData;

            if (!textInfo) return [];

            const { text, fontFamily } = textInfo;
            const ret: Array<{ fontFamily: string; text: string }> = [{ fontFamily, text }];

            const { listStyle } = textInfo;
            if (listStyle && listStyle !== 'custom') {
                const paragraphCount = Math.max(text.split('\n').length, 1);
                const markerText = Array.from({ length: paragraphCount }, (_, index) =>
                    getCharTypedMarkerText(listStyle, index + 1),
                ).join('');
                ret.push({ fontFamily, text: markerText });
            }

            return ret;
        },
    };

    return behaviors;
};
